import { Orca } from "@washingtonpost/media-components/core/index";
import React, { useCallback, useEffect, useState } from "react";
import { Events } from "./constants";
import { WapoLinks } from "./WapoLinks";
import PropTypes from "prop-types";
import { StickyPlayerProvider } from "@washingtonpost/media-components/core/audio/StickyPlayer";

export const ReactWrapper = ({ settings, uniqueId, attachDomNode }) => {
  const [orcaProps, setProps] = useState({ ...settings });

  useEffect(() => {
    window.addEventListener(Events.PROPS_UPDATED, e => {
      if (e.detail.id === uniqueId) {
        setProps(e.detail.props);
      }
    });
  }, [uniqueId]);

  const { onVideoRendered: onRenderProp } = orcaProps;

  const onVideoRendered = useCallback(
    ({ node, orcaPlayer }) => {
      attachDomNode({
        node,
        orcaPlayer
      });
      if (onRenderProp) {
        onRenderProp();
      }
    },
    [attachDomNode, onRenderProp]
  );

  return (
    <>
      {/** Load wapo assets */}
      <WapoLinks />
      <StickyPlayerProvider>
        <Orca {...orcaProps} onVideoRendered={onVideoRendered} />
      </StickyPlayerProvider>
    </>
  );
};

ReactWrapper.propTypes = {
  settings: PropTypes.object,
  uniqueId: PropTypes.string,
  attachDomNode: PropTypes.func
};
